import React, { memo } from 'react';
import { StepperTypeTokens, } from '@voltmoney/schema';
import { StepperBase } from './Stepper.base';
import StepperHorizontalBase from './StepperHorizontal.base';
import StepperDistributorBase from './StepperDistributor.base';
import { StepperPartnerBase } from './StepperPartner.base';
const Stepper = ({ type = StepperTypeTokens.VERTICAL, onPress, isProcessing, highlightText, isForeclosureDetails, ...props }) => {
    switch (type) {
        case StepperTypeTokens.VERTICAL:
            return (React.createElement(StepperBase, { type: type, onPress: onPress, isProcessing: isProcessing, highlightText: highlightText, isForeclosureDetails: isForeclosureDetails, ...props }));
        case StepperTypeTokens.HORIZONTAL:
            return (React.createElement(StepperHorizontalBase, { type: type, onPress: onPress, ...props }));
        case StepperTypeTokens.DISTRIBUTOR:
            return (React.createElement(StepperDistributorBase, { type: type, onPress: onPress, ...props }));
        case StepperTypeTokens.PARTNER:
            return (React.createElement(StepperPartnerBase, { type: type, onPress: onPress, ...props }));
        default:
            return React.createElement(React.Fragment, null);
    }
};
export default memo(Stepper);
export { Stepper };
